import script from "./EmpresasSection.vue?vue&type=script&setup=true&lang=js"
export * from "./EmpresasSection.vue?vue&type=script&setup=true&lang=js"

import "./EmpresasSection.vue?vue&type=style&index=0&id=b39262c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b39262c8"]])

export default __exports__